import { ErrorPageFragment, SearchLandingPageBySlug } from '../types';

export const isSearchLandingPageBySlugErrorPage = (
  response: SearchLandingPageBySlug,
): response is ErrorPageFragment => {
  return response && 'errorCode' in response;
};

export const isNotFoundErrorPage = (errorPage: ErrorPageFragment): boolean =>
  errorPage.errorCode === 404;
